import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";
import queryString from 'query-string';

export default function Useguidelist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const target = useRef(null);

    const urlParameter = window.location.search;
    const query = queryString.parse(urlParameter);
    console.log("???????", query?.cate);

    const [memberinfos, setmemberinfos] = useState(''); 
    const [faqcate, setfaqcate] = useState(configdata?.guide_cate);   
    const [faqselcate, setfaqselcate] = useState(query?.cate ? query?.cate : '[CBT] 매물');   
    /*
    https://maemul.net/UseguidelistV?cate=[CBT] 매물
    https://maemul.net/UseguidelistV?cate=[CBT] 고객
    https://maemul.net/UseguidelistV?cate=[CBT] 매칭/공동중개
    https://maemul.net/UseguidelistV?cate=[CBT] 기타
    */

    const [lists, setlists] = useState([]); 
    const [selfaqidx, setselfaqidx] = useState('');   
    const [page, setPage] = useState(0);   

    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
   
    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
    }, [faqselcate]);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            cate: faqselcate
        }
        APIS.postData('/v1/guide/list', sender).then(({ data }) => {
            if(data){
                setlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }


    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>

                <div className='customercenterPage' style={{ borderRadius: 20 }}>
                    <div className='fontsize24 bolds'>이용가이드</div>
                    <div>
                        <div className='faqlistArea'>
                            {lists?.length > 0 && lists?.map((x, i) => {
                                if(i > (page*10)){
                                    return;
                                }
                                return (
                                    <div 
                                        className={`faqlistView `}
                                        key={i}
                                        style={{
                                            cursor: 'pointer', 
                                        }}
                                        onClick={() => {
                                            navigate('/UseguideDetailV', {state: { vidx: x?.idx }});
                                        }}
                                    >
                                        <div>
                                            <div 
                                                className='textcut_online'
                                                style={{ 
                                                    display: 'inline-block', width: 'calc(100% - 140px)', textAlign: 'left',
                                                    fontWeight: 700, fontSize: 16
                                                }}
                                            >
                                                {x?.title}
                                            </div>  
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.34868 2.01567C6.81359 1.55076 7.56736 1.55076 8.03227 2.01567L15.1751 9.15853C15.64 9.62344 15.64 10.3772 15.1751 10.8421L8.03227 17.985C7.56736 18.4499 6.81359 18.4499 6.34868 17.985C5.88377 17.5201 5.88377 16.7663 6.34868 16.3014L12.6497 10.0003L6.34868 3.69926C5.88377 3.23435 5.88377 2.48058 6.34868 2.01567Z" fill="#333333"/>
                                                </svg>
                                            </div>  
                                        </div>
                                    </div>
                                );
                            })}
                            {lists?.length === 0 &&
                                <div className='nolistArea'>
                                    이용가이드가 없습니다.
                                </div>
                            }
                            <div ref={target} style={{ width: '100%', height: 1 }} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

